export const GALLERY_STOCK_KEY = "clNHz3iNWZNjGzUd67NNpYmWEftD9yj2UK9hL3Dgqqw";
export const STOCK_URL = "https://api.unsplash.com";